// extracted by mini-css-extract-plugin
export default {"cardDiv":"CardMed_cardDiv__770Wq","foto":"CardMed_foto__i+Ih4","cargo":"CardMed_cargo__gaMIl"};